import { jwtDecode } from "jwt-decode";
import { setAuth } from "../../store/reducers/user-reducer";
import UserService from "../UserService";
import useFetch from "../../hooks/useFetch";
import { useAppDispatch } from "../../store";

export default function useAuthorization() {
    const access_token = localStorage.getItem('accessToken')
    const dispatch = useAppDispatch()
    const checkAuth = async () => {
            if(access_token) {
                console.log(access_token)
                const decoded_token = jwtDecode(access_token)
                dispatch(setAuth(decoded_token))
            }
            else {
                const tokens = await UserService.Refresh()
                const decoded_token = jwtDecode(tokens.tokens.access_token)
                localStorage.setItem('accessToken', tokens.tokens.access_token)
                console.log(tokens.tokens.access_token)
                dispatch(setAuth(decoded_token))
            }
        
    
    }
    const [authorization, isLoading, error, errors] = useFetch(checkAuth)
    return {authorization, isLoading, error, errors}
}